import React, { useState, useCallback } from 'react';
import { useSound } from '../../contexts/SoundContext';
import { ABOUT_INFO } from '../../utils/constants';
import styles from './LoginScreen.module.css';

interface LoginScreenProps {
  onLogin: () => void;
}

export const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin }) => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [password, setPassword] = useState('');
  const { playSound } = useSound();

  const handleLogin = useCallback(() => {
    setIsLoggingIn(true);
    playSound('logon');
    // Simulate login delay
    setTimeout(() => {
      onLogin();
    }, 800);
  }, [onLogin, playSound]);

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    handleLogin();
  }, [handleLogin]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  }, [handleLogin]);

  return (
    <div className={`${styles.loginScreen} ${isLoggingIn ? styles.loggingIn : ''}`}>
      {/* Background gradient - XP Welcome Screen style */}
      <div className={styles.background}>
        <div className={styles.gradientTop} />
        <div className={styles.gradientBottom} />
      </div>

      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
        </div>
      </header>

      {/* Main content area */}
      <main className={styles.main}>
        {/* Windows XP branding on the left */}
        <div className={styles.branding}>
          <img
            src="/icons/windows-logo.png"
            alt="Windows"
            className={styles.windowsLogo}
          />
          <div className={styles.brandingText}>
            <span className={styles.microsoft}>Microsoft</span>
            <span className={styles.windowsXp}>
              Windows<span className={styles.xp}>XP</span>
            </span>
          </div>
        </div>

        {/* Separator line */}
        <div className={styles.separator} />

        {/* User accounts */}
        <div className={styles.userList}>
          <button
            className={`${styles.userCard} ${styles.active}`}
            onClick={handleLogin}
            onKeyDown={handleKeyDown}
            disabled={isLoggingIn}
          >
            <div className={styles.avatarContainer}>
              <div className={styles.avatar}>
                <img
                  src="/profile-login.jpg"
                  alt={ABOUT_INFO.name}
                />
              </div>
            </div>
            <div className={styles.userInfo}>
              <span className={styles.userName}>{ABOUT_INFO.name}</span>
              {isLoggingIn ? (
                <span className={styles.loggingInText}>Loading personal settings...</span>
              ) : (
                <span className={styles.userHint}>Click to log in</span>
              )}
            </div>
            {isLoggingIn && (
              <div className={styles.loadingIndicator}>
                <div className={styles.spinner} />
              </div>
            )}
          </button>

          {/* Optional password field (decorative) */}
          <form className={styles.passwordForm} onSubmit={handleSubmit} style={{ display: 'none' }}>
            <label className={styles.passwordLabel}>
              Type your password
              <input
                type="password"
                className={styles.passwordInput}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoggingIn}
                autoFocus
              />
            </label>
            <button type="submit" className={styles.submitButton} disabled={isLoggingIn}>
              →
            </button>
          </form>
        </div>
      </main>

    </div>
  );
};

export default LoginScreen;
